<template>
  <div class="flex flex-col h-full">
    <lerner-header :show-login-form="false" :pending="pending"></lerner-header>
    <page-header title="Reset Your Password"></page-header>
    <ForgotPasswordForm v-on:submit="submitForgotPassword" class="flex-1"/>
    <app-footer v-if="!isAuthenticated" :pages="pages" class="w-full pin-b"></app-footer>
    <student-footer v-if="isAuthenticated"></student-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import AppFooter from '@/component/AppFooter';
  import LernerHeader from '@/component/Header';
  import ForgotPasswordForm from './ForgotPasswordForm';
  import AuthService from '@/common/services/auth.service';
  import PageHeader from '@/component/PageHeader';
  import { CHANGE_DOC_TITLE, SHOW_NOTIFICATION } from '@/store/actions/app.actions';
  import { getError } from '@/common/services/http.service';
  import StudentFooter from '../Student/StudentFooter.vue';

  export default {
    name: 'ForgotPassword',

    components: {
      PageHeader,
      ForgotPasswordForm,
      LernerHeader,
      AppFooter,
      StudentFooter
    },

    data: () => {
      return {
        pending: false
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Reset Your Password', useBaseTitle: true})
    },

    computed: {
      ...mapGetters([
        'pages'
      ]),
      isAuthenticated: function () {
        return AuthService.isAuthenticated();
      }
    },

    methods: {
      submitForgotPassword(data) {
        this.pending = true;

        AuthService.forgotPassword(data)
            .then(() => {
              this.$store.dispatch(SHOW_NOTIFICATION, {
                type: 'success',
                message: 'Please check your email to reset your password.'
              });
              this.$router.push({name: 'home'});
            })
            .catch(e => this.$store.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(e)}))
            .finally(() => this.pending = false);
      }
    }
  };
</script>
